import * as React from 'react';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {canReissueCardSelector} from '../../../../../redux/selectors/cardReissue';
import {contentSelector} from '../../../../../redux/selectors/resources';
import {GetHolderProfileCabinetResponsePayload} from '../../../../../shared/models/api';
import View from './view';
import {CardStatus} from '../../../../../types/enums/cardStatus';

export const ProfileSafety = () => {
  const content = useSelector(contentSelector());
  const {cardStatusId} = (useSelector(holderProfileSelector()) as GetHolderProfileCabinetResponsePayload) || {};
  const canReissueCard = useSelector(canReissueCardSelector());

  return <View cardIsBlocked={cardStatusId === CardStatus.Blocked} canReissueCard={canReissueCard} content={content} />;
};
